import React from 'react';
import styled from 'styled-components';
import { Button } from '../styles/Button';
import { Toaster } from 'react-hot-toast';


const AddressForm = ({ formAddress,
  setFormAddress,
  handleChange,
  handleCountryChange,
  handleStateChange,
  handleSubmit,
  handleReset,
  handleUpdate,
  countries = [],
  states = [],
  cities = [],
  selectedCountry,
  selectedState,
  auth,
  submitLabel = "Add Address" }) => {

  return (
    <Wrapper>

      <div class="container">
        <Toaster position="top-right" reverseOrder={false} />

        <div class="form-container">
          <div class="address-section" autoComplete="off">
            <label for="name" >Full Name</label>
            <input type="text" id="name" placeholder="John Dev"
              value={formAddress.name}
              onChange={handleChange} />

            <label for="address" >Address</label>
            <input type="text"
              id="street_add"
              placeholder="123 Main St"
              value={formAddress.street_add}
              onChange={handleChange} />

            <div className='addr-detail'>
              <label for="country">Country</label>
              <select
                id="country"
                value={formAddress.country}
                onChange={(e) =>
                  handleCountryChange(
                    countries.find((c) => c.name === e.target.value),
                  )}>
                <option value=''>select Country</option>
                {countries.map((country) => (
                  <option key={country.isoCode}
                    value={country.name}>{country.name}
                  </option>
                ))}
              </select>
            </div>

            <div className='addr-detail'>
              <label for="state">State/Province</label>
              {/* <input type="text" id="state_province" placeholder="New York" value={formAddress.state_province}
                                    onChange={handleChange}/>       */}
              <select id="state"
                disabled={!selectedCountry}
                value={formAddress.state_province}
                onChange={(e) =>
                  handleStateChange(
                    states.find((s) => s.name === e.target.value),
                  )}>
                <option value=''>Select State</option>
                {states.map((state) => (
                  <option key={state.isoCode} value={state.name}>{state.name}
                  </option>
                ))}
              </select>
            </div>

            <div className='addr-detail'>
              <label for="city">City</label>
              {/* <input type="text" id="city" placeholder="New York" value={formAddress.city}
                                        onChange={handleChange}/> */}
              <select
                id="city"
                disabled={!selectedState}
                value={formAddress.city}
                onChange={(e) =>
                  setFormAddress((prev) => ({
                    ...prev,
                    city: e.target.value,
                  }))
                }
              >
                <option value=''>Select City</option>
                {cities.map((city) => (
                  <option key={city.name} value={city.name}>{city.name}
                  </option>
                ))}
              </select>
            </div>
            <div className='addr-detail'>
              <label htmlFor="phone No">Phone No.</label>
              <div style={{ display: "flex", alignItems: "center", gap: "0.5rem" }}>
                <input
                  type="text"
                  value={formAddress.isdCode ? `+${formAddress.isdCode}` : ""}
                  readOnly
                  style={{ width: "80px", }}
                />
                <input
                  type="number"
                  id="phone"
                  placeholder='Phone No.'
                  value={formAddress.phone}
                  onChange={handleChange} />
              </div>
            </div>
            <div className='addr-detail'>
              <label for="zip">Zip/Postal Code</label>
              <input type="number"
                id="zipcode"
                placeholder="10001"
                value={formAddress.zipcode}
                onChange={handleChange} />
            </div>

          </div>

        </div>
        <div className="two-button">
          <Button className="btn-two"
            type="button"
            onClick={() =>
              setFormAddress({
                name: auth?.user?.username || "",
                street_add: "",
                city: "",
                state_province: "",
                country: "",
                zipcode: "",
                phone: "",
                isdCode: ""
              })
            }
          >
            Reset
          </Button>

          {formAddress._id && (
            <Button type="button" onClick={handleUpdate}
            style={{ backgroundColor: "#6F9F86", color: "#fff" }}>
              Update
            </Button>
          )}
          <Button type="submit" onClick={handleSubmit}>
            {submitLabel}
          </Button>
        </div>
      </div>
    </Wrapper>
  )
}


const Wrapper = styled.section`
  .form-container {
    width: 100%;
  }

  label {
    display: block;
    margin-top: 10px;
    font-weight: bold;
  }

  input,
  select {
    width: 100%;
    padding: 10px;
    margin-top: 5px;
    box-sizing: border-box;
    border: 1px solid #ccc;
    border-radius: 4px;
  }

  Button{
    width: 10rem;
    hight: auto;
    padding: 0.5rem;
    margin: 1rem;}
 `;

export default AddressForm;